import { createActionCreator, createReducer } from 'deox';
import { ReplaceSceneContent } from 'types/ReplaceSceneContent';
import { AppState } from 'types/AppState';

const defaultState: ReplaceSceneContent = {
  isReplaceAvailable: false,
  isReplacing: false
};

export const setReplaceAvailable = createActionCreator(
  'REPLACE/SET_AVAILABLE',
  resolve => (isAvailable: boolean) => resolve(isAvailable)
);
export const setReplacing = createActionCreator('REPLACE/SET_REPLACING');

export const replaceSceneContent = createReducer(defaultState, handle => [
  handle(setReplaceAvailable, (_, { payload }) => ({
    isReplaceAvailable: payload,
    isReplacing: false
  })),
  handle(setReplacing, () => ({ isReplaceAvailable: true, isReplacing: true }))
]);

export const getReplaceState = (state: AppState): ReplaceSceneContent => state.replaceSceneContent;
